export default {
  'batchDeduct.batchCode.title': 'รหัสยืนยันการใช้สิทธิ์',
  'batchDeduct.batchCode.warning':
    'สำหรับผู้ถือสิทธิ์เท่านั้น การถ่ายภาพหรือบันทึกหน้าจอไม่สามารถใช้แทนได้',
  'batchDeduct.batchCode.code': 'รายละเอียดการใช้สิทธิ์ครั้งนี้',
  'batchDeduct.batchCode.counts': 'รายการ',
  'batchDeduct.batchCode.copySuccess': 'คัดลอกรหัสยืนยันสำเร็จ',
  'batchDeduct.batchCode.success': 'ยืนยันการใช้สิทธิ์สำเร็จ',
  'batchDeduct.batchCode.produce_fail': 'ไม่สามารถสร้างรหัสยืนยันได้',
  'batchDeduct.title': 'การยืนยันสิทธิ์แบบกลุ่ม',
  'batchDeduct.error.stamp_no_permission': 'ไม่มีสิทธิ์การใช้คูปองดังต่อไปนี้',
  'batchDeduct.cancel_all': 'ยกเลิกทั้งหมด',
  'batchDeduct.partial_deduct': 'ยืนยันการใช้สิทธิ์บางส่วน',
  'batchDeduct.message.following_ticket_deduct_success':
    'คูปองต่อไปนี้ได้รับการยืนยันสิทธิ์เรียบร้อยแล้ว',
} as Record<string, string>;
